<template>
    <div>
        <div class="panel-body">
            <div class="form-group">
                <span v-for="(suggestion, idx) in phoneticOutput.suggestions" :key="idx">
                    <DropdownSelector :index="idx"
                                      :options="suggestion.options"
                                      :selected="suggestion.selected || 0"
                                      @optionSelected="handleOptionSelected" >
                    </DropdownSelector>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropdownSelector from './DropdownSelector';

export default {
    name: 'PhoneticSuggestions',
    components: { DropdownSelector },
    computed: {
        ...mapGetters({
            phoneticOutput: 'phoneticOutput'
        })
    },
    methods: {
        handleOptionSelected (index, value) {
            value = parseInt(value);
            this.$store.commit('phonetic/UPDATE_SUGGESTIONS_SELECTION', {
                index,
                value
            });
        }
    }
};
</script>

<style scoped>

</style>
